export const distributionChannels = {
    'de-DE': 'raisin_direct_retail_deu',
    'de-AT': 'raisin_direct_retail_aut',
    'en-US': 'raisin_direct_retail_eur',
    'en-GB': 'raisin_direct_retail_gbr',
    'en-IE': 'raisin_direct_retail_irl',
    'es-ES': 'raisin_direct_retail_esp',
    'nl-NL': 'raisin_direct_retail_nld',
    'fr-FR': 'raisin_direct_retail_fra',
    'pl-PL': 'raisin_direct_retail_pol',
    'fi-FI': 'raisin_direct_retail_fin',
};
export const COUNTRIES_DISTRIBUTION_CHANNELS = {
    DEU: distributionChannels['de-DE'],
    AUT: distributionChannels['de-AT'],
    USA: distributionChannels['en-US'],
    GBR: distributionChannels['en-GB'],
    IRL: distributionChannels['en-IE'],
    ESP: distributionChannels['es-ES'],
    NLD: distributionChannels['nl-NL'],
    FRA: distributionChannels['fr-FR'],
    POL: distributionChannels['pl-PL'],
    FIN: distributionChannels['fi-FI'],
};
//# sourceMappingURL=distributionChannels.js.map